export const mapBoxKeys = {
  ACCESS_TOKEN: 'pk.eyJ1Ijoic2JtLXRlc3QiLCJhIjoiY2t5NGZtcWw5MGJrOTJvcW5jZm0wNzgwbyJ9.H-bOofFfUdoKcqqJRcBmjQ',
  MAP_ORANGE: 'mapbox://styles/sbm-test/cky8ggd2j1vwv15qmsgot36um',
  MAP_BLUE: 'mapbox://styles/sbm-test/ckz78oqjl003114nju7v4z5kt'
}
